import { Wallet, Plus, Sliders } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

function fmtKm(n: number): string {
  return `${new Intl.NumberFormat("bs-BA", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n)} KM`;
}

export function CreditBalanceCard({
  balance,
  onRecharge,
  onAdjust,
}: {
  balance: number;
  onRecharge: () => void;
  onAdjust: () => void;
}) {
  return (
    <div className="rounded-xl border border-border/60 bg-card p-5 shadow-sm">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <div className="flex items-center gap-2 text-muted-foreground">
            <Wallet className="size-4" />
            <span className="text-[11px] font-semibold uppercase tracking-widest">Stanje kredita</span>
          </div>
          <p className="mt-2 text-3xl font-bold tabular-nums text-foreground">{fmtKm(balance)}</p>
        </div>
        <div className="flex flex-col gap-2 sm:flex-row">
          <Button size="sm" onClick={onRecharge}>
            <Plus className="size-4" /> Dopuni kredit
          </Button>
          <Button size="sm" variant="outline" onClick={onAdjust}>
            <Sliders className="size-4" /> Ručna korekcija
          </Button>
        </div>
      </div>
    </div>
  );
}
